import styled from 'styled-components'
import { media } from '../utils/media'

export const IntakeStepContainer = styled.div<{ active: boolean }>`
  ${({ active }) => !active && `
    opacity: 0.3;
  `}

  margin-bottom: 10px;

  ${media.tablet`
    display: flex;
    justify-content: center;
  `}
`



// WEBPACK FOOTER //
// ./src/atoms/IntakeStepContainer.tsx